/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/commonClasses/commonContextBase.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.Aveda {
    "use strict";

    export class AvedaContext extends Meevo.Components.CommonClasses.CommonContextBase {
                                      
        protected loading: boolean;
        public auditNoun = Meevo.Model.NounEnum.Aveda;

        public hasAccessToV2: boolean;

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            businessInfoDataService: Meevo.Components.CommonClasses.ICommonDataService,
            protected identityDataService: Meevo.Components.Common.ICommonDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $http: angular.IHttpService,
            protected $rootScope: angular.IRootScopeService
        ) {
            super(appSettings, businessInfoDataService, modalService, identityService, loggingService, securityChecker, trackingService);

            this.baseEndpoint = appSettings.API_ENDPOINTS.aveda;
            this.sectionTemplatePath = "app/plugins/aveda/sectionViews/";
            this.buildCrudSecurityKeysBase(this.securityKeys.INTEGRATION_AVEDA_TAB_MAIN);
            this.initializeSections();
        }

        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INTEGRATION_AVEDA_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(
                    0,
                    "SECTION_MAIN",
                    "main.html",
                    true,
                    false,
                    this.baseEndpoint,
                    "",
                    this.loggingService,
                    this.dataService,
                    Meevo.Model.NounEnum.Aveda,
                    this.identityService,
                    this.appSettings,
                    this.modalService,
                    this.securityKeys.INTEGRATION_AVEDA_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    this.$rootScope)
                );
            }
            this.activate();
        }

        initializeHeader(model: any): void {
            this.headerContent = model.storeName;
        }

        save(): angular.IPromise<any> {
            let promise = super.save().then(() => {
                if (!this.isApplicationModeCO() && this.selectedSection.model.objectState == Meevo.Model.ObjectStateEnum.Active) {
                    this.modalService.message("MESSAGE_AVEDA_ACCOUNT_SUCCESS", Meevo.Components.Modal.ModalTranslationModes.Translate);
                }
            }, (reason: any) => {
               // this.modalService.alert('MESSAGE_AVEDA_ACCOUNT_FAILURE', Meevo.Components.Modal.ModalTranslationModes.Translate);
            });
            return promise;
        }

        addDistributor(): void {
            var aveda = this.currentAveda;
            if (aveda === undefined || aveda.distributor === undefined)
                return;

            if (_.find(aveda.distributor !== undefined
                && aveda.distributors, (ec) => {
                    return ec.displayName === aveda.distributor.displayName
                }) === undefined) {
                {
                    aveda.distributor.isAvedaOrderingEnabled = true;
                    aveda.distributors.push(aveda.distributor);
                    aveda.distributor = undefined;
                }
            }
            else {
                var index = _.findIndex(aveda.distributors, function (d) { return d.id == aveda.distributor.id })
                if (index < 0)
                    aveda.distributors[index].isAvedaOrderingEnabled = true;
            }
        }

        removeDistributor(index: number): void {
            var aveda = this.currentAveda;
            if (aveda === undefined || this.isReadonly)
                return;
            aveda.distributors[index].isAvedaOrderingEnabled=false;
        }

        get currentAveda(): Model.Aveda {
            return this.castModel<Model.Aveda>();
        }

        protected castModel<T>(): T {
            return this.verifySelectedSectionModel() ? <T>this.selectedSection.model : undefined;
        }

        public verifySelectedSectionModel(): boolean {
            return Model.Guard.isSomething(this.selectedSection)
                && Model.Guard.isSomething(this.selectedSection.model);
        }

    }
}

